import { Injectable } from "@angular/core";
import { SwUpdate } from "@angular/service-worker";
import { AlertController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";

@Injectable({ providedIn: "root" })
export class SwUpdateService {
  constructor(private swUpdate: SwUpdate, private alert: AlertController, private t: TranslateService) {}

  public async checkForUpdate(): Promise<void> {
    if (this.swUpdate.isEnabled) {
      const newVersionAvailable = await this.swUpdate.checkForUpdate();
      if (newVersionAvailable) this.updateToLatest();
    }
  }

  private async updateToLatest(): Promise<void> {
    const alert = await this.alert.create({
      backdropDismiss: false,
      header: this.t.instant("UPDATE_MODAL.TITLE"),
      message: this.t.instant("UPDATE_MODAL.DESCRIPTION"),
      buttons: [
        {
          role: "cancel",
          text: this.t.instant("UPDATE_MODAL.CANCEL"),
        },
        {
          text: this.t.instant("UPDATE_MODAL.APPROVE"),
          handler: async (): Promise<void> => {
            await this.swUpdate.activateUpdate();
            return document.location.reload();
          },
        },
      ],
    });
    await alert.present();
  }
}
